import {
  ProjectInformation,
  CostEstimation,
  Result,
  ProjectPlanPageState,
  InfoBar,
} from ".";

export const projectInformationInitialState: ProjectInformation = {
  pjtName: "",
  pjtDesc: "",
  pjtStartPlnDate: "",
  pjtEndPlnDate: "",
  chnTypeGrpTypeCdList: [],
  chnTypeGrpTypeName: "",
  trnsMsnTypeCd: "",
  trnsMsnTypeName: "",
  reqEstmtAnsDueDate: "",
};

export const costEstimationInitialState: CostEstimation = {
  pjtBdgtAcqstnReqTypeCd: "",
  pjtBdgtAcqstnReqTypeName: "",
  statsOfAgreementOnBudgetaryTypeCd: "",
  statsOfAgreementOnBudgetaryTypeName: "",
};

const resultInitialState: Result = {
  projectInformation: {},
  costEstimation: {},
  componentProjectList: [],
  stakeholderList: [],
  pjtLnchTypeCd: "",
  pjtLnchTypeName: "",
  updateDateTime: "",
  mmTxt: "",
  mmTxtUpdateDateTime: "",
};

const infoBarInitialState: InfoBar = {
  isShow: false,
  message: "",
  ready: "",
};

export const ProjectPlanPageInitialState: ProjectPlanPageState = {
  result: resultInitialState,
  infoBar: infoBarInitialState,
  loginUserRoleList: [],
  authorized: false,
};
